import React from "react";
import {classNames} from "@utils/class-names";

interface UndoButtonProps {
    onUndo: () => void;
}

const UndoButton = ({onUndo}: UndoButtonProps) => {
    return (
        <button
            type="button"
            onClick={onUndo}
            className={classNames(
                "px-2 w-10 h-10 hover:bg-on-surface/5 rounded-full flex items-center justify-center"
            )}
            title="Cofnij (Ctrl+Z)"
        >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                 strokeLinecap="round" strokeLinejoin="round">
                <polyline points="1 4 1 10 7 10"/>
                <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/>
            </svg>
        </button>
    );
};

export default UndoButton;